import { UserGetResponse } from '@lio/api-types';
import { userQueryKey } from '@services/user/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useGetUser = (userId?: string) => {
  const client = useClient();

  const result = useQuery<UserGetResponse>({
    queryKey: userQueryKey.getWithParams(userId ?? ''),
    queryFn: () => client.get(`user/${userId}`).json<UserGetResponse>(),
    enabled: userId !== undefined,
    refetchOnWindowFocus: false,
  });
  return { ...result, user: result.data };
};
